/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LoadingBar/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LoadingBar({
  children,
  viewPath = "/DesignSystem/LoadingBar",
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  marginTop,
  height,
  width
  
}) {
  return (<React.Fragment
>
<div
  data-testid="LoadingBar.Horizontal"
  data-view-path={viewPath}
 style={{'--bblr-1-Z2eJttO': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-2-Z2eJttO': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-3-Z2eJttO': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-4-Z2eJttO': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--mt-5-Z2eJttO': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--h-6-Z2eJttO': typeof height === 'number' ? `${height}px` : height,'--w-7-Z2eJttO': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="LoadingBar.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bblr-1-Z2eJttO': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-2-Z2eJttO': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-3-Z2eJttO': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-4-Z2eJttO': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-6-Z2eJttO': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Horizontal1}`}
/>
<div
  data-testid="LoadingBar.Horizontal:2"
  data-view-path={viewPath}
 style={{'--bblr-1-Z2eJttO': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-2-Z2eJttO': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-3-Z2eJttO': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-4-Z2eJttO': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-6-Z2eJttO': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Horizontal2}`}
/>
</div>
{children}
</React.Fragment>)
}